import { KoBadge, KoButton, KoDateFormatter,  KoInput, KoLoader, KoModal, KoText, KoTooltips } from 'packages';
import KoIcon from '@kwapio/icons';
import React, { useEffect, useState } from 'react';
import styles from './assertsView.module.scss';

import Driver from 'packages/drivers';
import { Header } from 'antd/es/layout/layout';
import FileTypeIcon from 'packages/richText/fileTypeIcon';

export default function AssertsView({ actions, showComments,isLoading, getComments, totalComments, onShare, onUpdateName, onDownload, onComments, fileDetails, savingTextStatus, canEdit, canComment, openFileCreate, setOpenFileCreate, onClose}) {
  const [fileName, setRenameDocument] = useState(fileDetails?.name || 'Untitled Document');
  useEffect(() => {
    getComments && getComments(fileDetails?.documentId);
  },[]);
  return (
    <KoModal
      className={'modalCustom'}
      title={ <Header className={styles.globalHeader}>
        <div className={styles.docHeader}>
          <div className={styles.docHeaderLeft}>
            <FileTypeIcon type={'docx'} size={32} />
            <KoInput styles={{ minWidth: fileName.length * 8 }} disabled={!canEdit} onChange={(e) => setRenameDocument(e.target.value)} onBlur={() => onUpdateName(fileName)} className={`${styles.titleInput} ${canEdit ? '' : styles.titleInputDisabled}`} value={fileName} />
          </div>
          <div className={styles.docHeaderRight}>
            {isLoading && <div className={styles.loader}>
              <KoIcon color="#007867" name="RefreshOutlined" width={16} height={16} />
              <KoText className={styles.loaderText} text={savingTextStatus} />
            </div>}
            <KoTooltips title={<div className={styles.lastUpdated}>
              <KoText className={styles.lastUpdatedText} text={'Last Updated:'} />
              <KoDateFormatter className={styles.lastUpdatedDate} data={(fileDetails?.updatedAt && fileDetails?.updatedAt !== '0001-01-01T00:00:00Z') ? fileDetails?.updatedAt : (fileDetails?.createdAt ? fileDetails?.createdAt : fileDetails?.lastModifiedDate)} />
            </div>} placement="bottom">
              <KoButton iconBtn={true} color="default" variant="filled" icon={<KoIcon width={16} height={16} name={'LogOutlined'} />} />
            </KoTooltips>
            {actions.includes('comments') && <KoTooltips title={'Comments'} placement="bottom">
              <KoBadge count={totalComments} >
                <KoButton disabled={!canEdit && !canComment} onClick={onComments} iconBtn={true} color="default" variant="filled" icon={<KoIcon width={20} height={20} name={'ChatOutlined'} />} />
              </KoBadge>
            </KoTooltips>}
            {actions.includes('share') && <KoTooltips
              title={`Shared with ${fileDetails?.sharedWith?.users?.length || 0
                  } ${fileDetails?.sharedWith?.users?.length === 1 ? 'person' : 'people'} & ${fileDetails?.sharedWith?.groups?.length || 0
                  } ${fileDetails?.sharedWith?.groups?.length === 1 ? 'group' : 'groups'}`}
              placement="bottom"
            >
              <KoButton disabled={!canEdit} onClick={onShare} className={styles.shareButton} color="default" variant="filled" label='Share' icon={<KoIcon width={20} height={20} name={'AddtoGroupsOutlined'} color={'#FFF'} />} />
            </KoTooltips>}
            {actions.includes('download') && <KoTooltips title={'Download'} placement="bottom">
              <KoButton loader={isLoading} onClick={onDownload} iconBtn={true} color="default" variant="filled" icon={<KoIcon width={20} height={20} name={'DownloadOutlined'} />} />
            </KoTooltips>}
            <KoTooltips title={'Close'} placement="bottom">
              <KoButton  onClick={()=>setOpenFileCreate(false)} iconBtn={true} color="default" variant="filled" icon={<KoIcon width={12} height={12} name={'CloseOutlined'} />} />
            </KoTooltips>
          </div>
        </div>
      </Header>}
      centered
      open={openFileCreate}
      handleOk={() => { setOpenFileCreate(false); }}
      onClose={() => { setOpenFileCreate(false); onClose && onClose(); }}
      width={'100vw'}
      footer={false}
    >
      <div className={`${ (showComments && fileDetails?.documentId )? styles.container : ''}`}>
        <div className={styles.wrapper}>
          {isLoading && <KoLoader />}
          <div className={styles.mediaPreview}>
            <Driver fileType={fileDetails?.type} filePath={fileDetails?.url} />
          </div>
         
        </div>
      </div>
    </KoModal>
  );
}